import React from "react";
import Blockies from "react-blockies";

import { AvatarIcon } from "../Icon/icons/Avatar";
import { shortenAddress } from "../../utils";
import Flex from "../Flex";

import * as SC from "./WalletConnected.styles";

interface WalletConnectedProps {
  title?: string;
  address?: string;
  addresses?: string[];
  signed: boolean;
}

export const WalletConnected = ({ title, address, addresses, signed }: WalletConnectedProps) => {
  return (
    <SC.WalletConnectedContainer>
      <Flex width="100%" align="center" justify="between">
        <Flex align="center">
          <SC.AvatarContainer>
            {address ? <Blockies seed={address?.toLowerCase()} scale={5} /> : <AvatarIcon size={40}/>}
          </SC.AvatarContainer>
          <SC.AddressesContainer>
            <span>{title || shortenAddress(address)}</span>
            {(addresses || []).map(_ => <SC.Address key={_}>{shortenAddress(_)}</SC.Address>)}
          </SC.AddressesContainer>
        </Flex>
        {signed && <label>Signed</label>}
      </Flex>
    </SC.WalletConnectedContainer>
  );
};
